var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagReship(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1784781788444,
    className: "icon",
    viewBox: "0 0 1149 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 32134,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.859375,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M925.491101 732.208434c-2.626904-56.43739-43.83646-85.866923-109.509058-111.19192l-324.545776-122.151034V316.172519h129.37502l-209.003046-316.049383-209.044092 316.049383h129.416066v125.845118q-0.944044 12.970338-0.697772 25.940676v60.993427c3.242585 48.515633 54.30303 66.862915 71.377907 77.124258l363.374699 157.285875v214.503126h159.256052v-245.574475zM0 0h124.654802v1023.917909H0z m1024.615681 0H1149.270483v1023.917909h-124.860029z",
    fill: "#ffffff",
    "p-id": 32135
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagReship);
export default __webpack_public_path__ + "static/media/bagReship.d2ba1cd635a783fdcfb037fde1d008e4.svg";
export { ForwardRef as ReactComponent };